export const ONE_MINUTE = 60 * 1000;
export const MAX_TIME_SIMPLE_FILE_TYPE = 6;
export const MAX_TIME_COMPLEX_FILE_TYPE = 12;
